import { apiConfig } from "./config";

export const orderApi = {
  activeOrders: async () => {
    const response = await apiConfig.get("/api/front/chef/active-orders");
    return response;
  },
};
